export { applySignInError, getAuthErrorMessage } from "@medly/auth-config";
